import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/creators/{creatorId}/billing-invoices/next']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getNextBillingInvoice = async ({ creatorId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/creators/{creatorId}/billing-invoices/next', { creatorId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getNextBillingInvoice;
